"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProvidePanorama = exports.PanoramaProvider = exports.usePanorama = void 0;
const react_1 = __importStar(require("react"));
const PanoramaContext = (0, react_1.createContext)({
    url: "",
    isOpened: false,
    open: () => { },
    setList: () => { },
    list: [],
    initialized: false,
    close: () => { },
    location: null,
    _setLocation: () => { },
    yaw: 0,
    _setYaw: () => { }
});
const usePanorama = () => {
    const panorama = (0, react_1.useContext)(PanoramaContext);
    if (!panorama.initialized) {
        throw new Error('usePanorama must be used within a PanoramaProvider');
    }
    return panorama;
};
exports.usePanorama = usePanorama;
const PanoramaProvider = ({ children }) => {
    const panorama = (0, exports.useProvidePanorama)();
    return (react_1.default.createElement(PanoramaContext.Provider, { value: panorama }, children));
};
exports.PanoramaProvider = PanoramaProvider;
const useProvidePanorama = () => {
    const [url, setUrl] = react_1.default.useState("");
    const [isOpened, setIsOpened] = react_1.default.useState(false);
    const [list, sl] = react_1.default.useState([]);
    const [location, _setLocation] = react_1.default.useState(null);
    const [yaw, _setYaw] = react_1.default.useState(0);
    const setList = (list) => {
        sl(list);
    };
    const open = (url) => {
        setUrl(url);
        setIsOpened(true);
    };
    const close = () => {
        setIsOpened(false);
    };
    return {
        list,
        setList,
        open, close,
        url, isOpened,
        initialized: true,
        location, _setLocation,
        yaw, _setYaw
    };
};
exports.useProvidePanorama = useProvidePanorama;
